import {request} from '@@/plugin-request/request';
import session from '@/components/utils/session';
import {message} from 'antd';

export const errorHandler = (error: any, rsp: any) => {
  console.log('请求失败：', error.response);
  if (error.response) {
    // 请求已发出，但服务器响应的状态码不在 2xx 范围内
    if(error.response.status === 403 || error.response.status === 401){
      session.clear();
      setTimeout(() => {
        window.location.href = '/#/user/login';
      }, 3000);
    }else{
      message.error(`请求失败：${error.message}`);
    }
  } else {
    message.error(`请求失败：${error.message}`);
  }
  return rsp;
};

const tableResultWrap = <T>(res: CbAPI.ResultDto<T>): CbAPI.TableResult<T> => {
  return {
    data: res.results,
    total: res.totalCount,
    success: true,
  };
};

export async function login(
  param: any,
  options?: { [key: string]: any },
): Promise<CbAPI.ResultDto<CbAPI.UserDto>> {
  return request<CbAPI.ResultDto<CbAPI.UserDto>>('/api/common/login', {
    method: 'POST',
    data: {...param},
    ...(options || {}),
  })
}

export async function outLogin(
  options?: { [key: string]: any },
): Promise<CbAPI.ResultDto<any>> {
  return request<CbAPI.ResultDto<any>>('/api/common/loginOut', {
    method: 'GET',
    ...(options || {}),
  })
}

// API Functions
export async function queryRegionStoryList  (
  params: {
    current?: number;
    pageSize?: number;
    name?: string;
    state?: string;
  },
  options?: { [key: string]: any },
): Promise<CbAPI.TableResult<CbAPI.RegionStoryDto>>{
  const { current = 1, pageSize = 10, ...rest } = params;
  const response = await request<CbAPI.ResultDto<CbAPI.RegionStoryDto>>(`/api/region/story/query`, {
    method: 'POST',
    data: {
      pageNum: current,
      pageSize,
      ...rest,
    },
    ...(options || {}),
  });
  return {
    data: response.results || [],
    total: response.totalCount || 0,
    success: response.code === 200,
  };
};

export async function addRegionStory(data: CbAPI.RegionStoryDto) {
  return request<CbAPI.ResultDto<CbAPI.RegionStoryDto>>(`/api/region/story/add`, {
    method: 'POST',
    data,
  });
};

export async function updateRegionStory(data: CbAPI.RegionStoryDto){
  return request<CbAPI.ResultDto<CbAPI.RegionStoryDto>>(`/api/region/story/update`, {
    method: 'POST',
    data,
  });
};

export async function deleteRegionStory(id: string){
  return request<CbAPI.ResultDto<any>>(`/api/region/story/delete`, {
    method: 'GET',
    params: { id },
  });
};

// BeanInfo API Functions
export async function queryBeanInfoList  (
  params: {
    current?: number;
    pageSize?: number;
    region?: string;
    variety?: string;
    processingMethod?: string;
    stockStatus?: string;
    state?: string;
  },
  options?: { [key: string]: any },
): Promise<CbAPI.TableResult<CbAPI.BeanInfoDto>>{
  const { current = 1, pageSize = 10, ...rest } = params;
  const response = await request<CbAPI.ResultDto<CbAPI.BeanInfoDto>>(`/api/bean/info/query`, {
    method: 'POST',
    data: {
      pageNum: current,
      pageSize,
      ...rest,
    },
    ...(options || {}),
  });
  return {
    data: response.results || [],
    total: response.totalCount || 0,
    success: response.code === 200,
  };
};

export async function addBeanInfo(data: CbAPI.BeanInfoDto) {
  return request<CbAPI.ResultDto<CbAPI.BeanInfoDto>>(`/api/bean/info/add`, {
    method: 'POST',
    data,
  });
};

export async function updateBeanInfo(data: CbAPI.BeanInfoDto){
  return request<CbAPI.ResultDto<CbAPI.BeanInfoDto>>(`/api/bean/info/update`, {
    method: 'POST',
    data,
  });
};

export async function deleteBeanInfo(id: string){
  return request<CbAPI.ResultDto<any>>(`/api/bean/info/delete`, {
    method: 'GET',
    params: { id },
  });
};

// TastingNote API Functions
export async function queryTastingNoteList(
  beanId: string,
  options?: { [key: string]: any },
): Promise<CbAPI.ResultDto<CbAPI.TastingNoteDto>> {
  return request<CbAPI.ResultDto<CbAPI.TastingNoteDto>>(`/api/taste/note/getByBeanId`, {
    method: 'GET',
    params: { beanId },
    ...(options || {}),
  });
}

export async function addTastingNote(data: CbAPI.TastingNoteDto) {
  return request<CbAPI.ResultDto<CbAPI.TastingNoteDto>>(`/api/taste/note/add`, {
    method: 'POST',
    data,
  });
}

export async function updateTastingNote(data: CbAPI.TastingNoteDto) {
  return request<CbAPI.ResultDto<CbAPI.TastingNoteDto>>(`/api/taste/note/update`, {
    method: 'POST',
    data,
  });
}

export async function deleteTastingNote(id: string) {
  return request<CbAPI.ResultDto<any>>(`/api/taste/note/delete`, {
    method: 'GET',
    params: { id },
  });
}

export async function getDictionList  (
  type: string,
): Promise<CbAPI.ResultDto<CbAPI.DictionDto>>{
  return request<CbAPI.ResultDto<CbAPI.DictionDto>>(`/api/diction/getDictionList`, {
    method: 'GET',
    params: { type },
  });
}

// Diction API Functions
export async function queryDictionList  (
  params: {
    current?: number;
    pageSize?: number;
    type?: string;
    name?: string;
    state?: string;
  },
  options?: { [key: string]: any },
): Promise<CbAPI.TableResult<CbAPI.DictionDto>>{
  const { current = 1, pageSize = 10, ...rest } = params;
  const response = await request<CbAPI.ResultDto<CbAPI.DictionDto>>(`/api/diction/query`, {
    method: 'POST',
    data: {
      pageNum: current,
      pageSize,
      ...rest,
    },
    ...(options || {}),
  });
  return {
    data: response.results || [],
    total: response.totalCount || 0,
    success: response.code === 200,
  };
};

export async function addDiction(data: CbAPI.DictionDto) {
  return request<CbAPI.ResultDto<CbAPI.DictionDto>>(`/api/diction/add`, {
    method: 'POST',
    data,
  });
};

export async function updateDiction(data: CbAPI.DictionDto){
  return request<CbAPI.ResultDto<CbAPI.DictionDto>>(`/api/diction/update`, {
    method: 'POST',
    data,
  });
};

export async function deleteDiction(id: string){
  return request<CbAPI.ResultDto<any>>(`/api/diction/delete`, {
    method: 'POST',
    data: { id },
  });
};

// OperateLog API Functions
export async function queryOperateLogList  (
  params: {
    current?: number;
    pageSize?: number;
    operate?: string;
    username?: string;
    operateResult?: boolean;
  },
  options?: { [key: string]: any },
): Promise<CbAPI.TableResult<CbAPI.OperateLogDto>>{
  const { current = 1, pageSize = 10, ...rest } = params;
  const response = await request<CbAPI.ResultDto<CbAPI.OperateLogDto>>(`/api/operate/log/query`, {
    method: 'POST',
    data: {
      pageNum: current,
      pageSize,
      ...rest,
    },
    ...(options || {}),
  });
  return {
    data: response.results || [],
    total: response.totalCount || 0,
    success: response.code === 200,
  };
};

export async function allOperate(){
  return request<CbAPI.ResultDto<CbAPI.KvDto>>(`/api/operate/log/getAllOperate`, {
    method: 'GET',
  });
};

export async function allUser(){
  return request<CbAPI.ResultDto<CbAPI.KvDto>>(`/api/operate/log/allUser`, {
    method: 'GET',
  });
};

// User API Functions
export async function getAllUser  (
  options?: { [key: string]: any },
): Promise<CbAPI.TableResult<CbAPI.UserDto>>{
  const response = await request<CbAPI.ResultDto<CbAPI.UserDto>>(`/api/user/getAllUser`, {
    method: 'GET',
    ...(options || {}),
  });
  return {
    data: response.results || [],
    total: response.results?.length || 0,
    success: response.code === 200,
  };
}

export async function saveUser(data: CbAPI.UserDto) {
  return request<CbAPI.ResultDto<CbAPI.UserDto>>(`/api/user/saveUser`, {
    method: 'POST',
    data: {...data},
  });
}

// PurchaseIntention API Functions
export async function queryPurchaseIntentionList  (
  params: {
    current?: number;
    pageSize?: number;
    companyName?: string;
    contactName?: string;
    contactPhone?: string;
    state?: string;
  },
  options?: { [key: string]: any },
): Promise<CbAPI.TableResult<CbAPI.PurchaseIntentionDto>>{
  const { current = 1, pageSize = 10, ...rest } = params;
  const response = await request<CbAPI.ResultDto<CbAPI.PurchaseIntentionDto>>(`/api/purchase/intention/query`, {
    method: 'POST',
    data: {
      pageNum: current,
      pageSize,
      ...rest,
    },
    ...(options || {}),
  });
  return {
    data: response.results || [],
    total: response.totalCount || 0,
    success: response.code === 200,
  };
};

export async function addPurchaseIntention(data: CbAPI.PurchaseIntentionDto) {
  return request<CbAPI.ResultDto<CbAPI.PurchaseIntentionDto>>(`/api/purchase/intention/add`, {
    method: 'POST',
    data,
  });
};

export async function updatePurchaseIntention(data: CbAPI.PurchaseIntentionDto){
  return request<CbAPI.ResultDto<CbAPI.PurchaseIntentionDto>>(`/api/purchase/intention/update`, {
    method: 'POST',
    data,
  });
};

export async function deletePurchaseIntention(id: string){
  return request<CbAPI.ResultDto<any>>(`/api/purchase/intention/delete`, {
    method: 'POST',
    data: { id },
  });
};

// BeanConsult API Functions
export async function queryBeanConsultList  (
  params: {
    current?: number;
    pageSize?: number;
    companyName?: string;
    contactName?: string;
    contactPhone?: string;
    state?: string;
  },
  options?: { [key: string]: any },
): Promise<CbAPI.TableResult<CbAPI.BeanConsultDto>>{
  const { current = 1, pageSize = 10, ...rest } = params;
  const response = await request<CbAPI.ResultDto<CbAPI.BeanConsultDto>>(`/api/bean/consult/query`, {
    method: 'POST',
    data: {
      pageNum: current,
      pageSize,
      ...rest,
    },
    ...(options || {}),
  });
  return {
    data: response.results || [],
    total: response.totalCount || 0,
    success: response.code === 200,
  };
};

export async function addBeanConsult(data: CbAPI.BeanConsultDto) {
  return request<CbAPI.ResultDto<CbAPI.BeanConsultDto>>(`/api/bean/consult/add`, {
    method: 'POST',
    data,
  });
};

export async function updateBeanConsult(data: CbAPI.BeanConsultDto){
  return request<CbAPI.ResultDto<CbAPI.BeanConsultDto>>(`/api/bean/consult/update`, {
    method: 'POST',
    data,
  });
};

export async function deleteBeanConsult(id: string){
  return request<CbAPI.ResultDto<any>>(`/api/bean/consult/delete`, {
    method: 'POST',
    data: { id },
  });
};

// ContactUs API Functions
export async function queryContactUsList  (
  params: {
    current?: number;
    pageSize?: number;
    companyName?: string;
    contactName?: string;
    contactPhone?: string;
    email?: string;
    state?: string;
  },
  options?: { [key: string]: any },
): Promise<CbAPI.TableResult<CbAPI.ContactUsFormDto>>{
  const { current = 1, pageSize = 10, ...rest } = params;
  const response = await request<CbAPI.ResultDto<CbAPI.ContactUsFormDto>>(`/api/contact-us-form/query`, {
    method: 'POST',
    data: {
      pageNum: current,
      pageSize,
      ...rest,
    },
    ...(options || {}),
  });
  return {
    data: response.results || [],
    total: response.totalCount || 0,
    success: response.code === 200,
  };
};

export async function addContactUs(data: CbAPI.ContactUsFormDto) {
  return request<CbAPI.ResultDto<CbAPI.ContactUsFormDto>>(`/api/contact-us-form/add`, {
    method: 'POST',
    data,
  });
};

export async function updateContactUs(data: CbAPI.ContactUsFormDto){
  return request<CbAPI.ResultDto<CbAPI.ContactUsFormDto>>(`/api/contact-us-form/update`, {
    method: 'POST',
    data,
  });
};

export async function deleteContactUs(id: string){
  return request<CbAPI.ResultDto<any>>(`/api/contact-us-form/delete`, {
    method: 'POST',
    data: { id },
  });
};

// TeamMember API Functions
export async function queryTeamMemberList  (
  params: {
    current?: number;
    pageSize?: number;
    name?: string;
    title?: string;
    show?: boolean;
  },
  options?: { [key: string]: any },
): Promise<CbAPI.TableResult<CbAPI.TeamMemberDto>>{
  const { current = 1, pageSize = 10, ...rest } = params;
  const response = await request<CbAPI.ResultDto<CbAPI.TeamMemberDto>>(`/api/team/member/query`, {
    method: 'POST',
    data: {
      pageNum: current,
      pageSize,
      ...rest,
    },
    ...(options || {}),
  });
  return {
    data: response.results || [],
    total: response.totalCount || 0,
    success: response.code === 200,
  };
};

export async function addTeamMember(data: CbAPI.TeamMemberDto) {
  return request<CbAPI.ResultDto<CbAPI.TeamMemberDto>>(`/api/team/member/add`, {
    method: 'POST',
    data,
  });
};

export async function updateTeamMember(data: CbAPI.TeamMemberDto){
  return request<CbAPI.ResultDto<CbAPI.TeamMemberDto>>(`/api/team/member/update`, {
    method: 'POST',
    data,
  });
};

export async function deleteTeamMember(id: string){
  return request<CbAPI.ResultDto<any>>(`/api/team/member/delete`, {
    method: 'GET',
    params: { id },
  });
};

export async function getAllTeamMembers(
  options?: { [key: string]: any },
): Promise<CbAPI.ResultDto<CbAPI.TeamMemberDto>> {
  return request<CbAPI.ResultDto<CbAPI.TeamMemberDto>>(`/api/team/member/getAll`, {
    method: 'GET',
    ...(options || {}),
  });
}

// CompanyInfo API Functions
export async function getCompanyInfo(){
  return request<CbAPI.ResultDto<CbAPI.CompanyInfoDto>>(`/api/company/info/get`, {
    method: 'GET',
  });
};

export async function updateCompanyInfo(data: CbAPI.CompanyInfoDto){
  return request<CbAPI.ResultDto<CbAPI.CompanyInfoDto>>(`/api/company/info/update`, {
    method: 'POST',
    data,
  });
};

export async function getDashboardData(params: {startTime: string, endTime: string}){
  return request<CbAPI.ResultDto<CbAPI.DashboardDto>>(`/api/dashboard/get`, {
    method: 'POST',
    data: {...params},
  });
};

// RegionPrice API Functions
export async function queryRegionPriceList(
  params: {
    current?: number;
    pageSize?: number;
    region?: string;
    grade?: string;
    brewMethod?: string;
    state?: string;
  },
  options?: { [key: string]: any },
): Promise<CbAPI.TableResult<CbAPI.RegionPriceDto>> {
  const { current = 1, pageSize = 10, ...rest } = params;
  const response = await request<CbAPI.ResultDto<CbAPI.RegionPriceDto>>(`/api/region/price/query`, {
    method: 'POST',
    data: {
      pageNum: current,
      pageSize,
      ...rest,
    },
    ...(options || {}),
  });
  return {
    data: response.results || [],
    total: response.totalCount || 0,
    success: response.code === 200,
  };
};

export async function addRegionPrice(data: CbAPI.RegionPriceDto) {
  return request<CbAPI.ResultDto<CbAPI.RegionPriceDto>>(`/api/region/price/add`, {
    method: 'POST',
    data,
  });
};

export async function updateRegionPrice(data: CbAPI.RegionPriceDto) {
  return request<CbAPI.ResultDto<CbAPI.RegionPriceDto>>(`/api/region/price/update`, {
    method: 'POST',
    data,
  });
};

export async function deleteRegionPrice(id: string) {
  return request<CbAPI.ResultDto<any>>(`/api/region/price/delete`, {
    method: 'GET',
    params: { id },
  });
};

export async function listAllRegionPrice() {
  return request<CbAPI.ResultDto<CbAPI.RegionPriceDto>>(`/api/region/price/listAll`, {
    method: 'GET',
  });
};

export async function clearAllRegionPrice() {
  return request<CbAPI.ResultDto<any>>(`/api/region/price/clearAll`, {
    method: 'GET',
  });
};

export async function exportRegionPrice() {
  return request(`/api/region/price/export`, {
    method: 'GET',
    responseType: 'blob',
  });
};

export async function importRegionPrice(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return request<CbAPI.ResultDto<any>>(`/api/region/price/import`, {
    method: 'POST',
    data: formData,
  });
};

export async function downloadRegionPriceTemplate() {
  return request(`/api/region/price/template`, {
    method: 'GET',
    responseType: 'blob',
  });
};
